// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container_5-ev5","chevron":"Detail_chevron_lVG0m","usersTable":"Detail_usersTable_BPEY4","urlArrow":"Detail_urlArrow_svrM0"};